<template>
  <span class="file-uploads file-uploads-html5">
    <slot>
      Thêm files...
    </slot>
    <label :for="inputId" />
    <input
      :id="inputId"
      type="file"
      name="file"
      :accept="accept"
      :multiple="multiple"
      @change="handleFileChange($event)"
    >
  </span>
</template>

<script>
import * as tus from '@/libs/tus.min';
// import { v5 as uuidv5 } from 'uuid';

export default {
  props: {
    inputId: {
      type: String,
      default: 'input-file',
    },
    uploadUrl: {
      type: String,
      default: '',
    },
    headers: {
      type: Object,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    chunkOptions: {
      type: Object,
      default: () => { },
    },
    accept: {
      type: String,
      default: 'image/*,audio/*,video/*',
    },
    acceptExtensions: {
      type: String,
      default: 'gif,jpg,jpeg,png,webp,mp3,wav,mp4,webm',
    },
    imageExtensions: {
      type: Array,
      default: () => ['jpg', 'jpeg', 'png', 'gif'],
    },
    audioExtensions: {
      type: Array,
      default: () => ['mp3', 'ogg'],
    },
    videoExtensions: {
      type: Array,
      default: () => ['mp4', 'm4v', 'ogv'],
    },
    documentExtensions: {
      type: Array,
      default: () => ['mp4', 'm4v', 'ogv'],
    },
    imageMimetypes: {
      type: Array,
      default: () => ['image/png', 'image/gif', 'image/jpeg', 'image/jpeg', 'image/jpeg', 'image/webp', 'image/bmp', 'image/heic', 'image/heif', 'image/tiff', 'image/svg-xml', 'image/ARW', 'image/x-eps', 'application/postscript'],
    },
    audioMimetypes: {
      type: Array,
      default: () => ['audio/mp3', 'audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/webm', 'audio/webm', 'audio/mpeg', 'audio/mpeg', 'audio/m4a', 'audio/3gpp', 'audio/x-ms-wma', 'audio/flac', 'audio/aiff', 'audio/aiff', 'audio/basic', 'audio/basic', 'audio/x-wav', 'audio/ac3', 'audio/aac', 'audio/x-aac', 'audio/x-hx-aac-adts', 'audio/x-m4a'],
    },
    videoMimetypes: {
      type: Array,
      default: () => ['video/mp4', 'video/mpeg', 'video/mpeg', 'video/ogg', 'video/webm', 'video/avi', 'video/x-msvideo', 'video/3gpp', 'video/x-matroska', 'video/x-ms-wmv', 'video/x-ms-asf', 'video/dvd', 'video/x-ms-vob', 'video/x-flv', 'application/mxf', 'video/mp2p', 'video/mp2t', 'application/gxf', 'video/quicktime', 'video/x-sgi-movie', 'video/h264', 'video/mp4'],
    },
    documentMimetypes: {
      type: Array,
      default: () => ['text/plain', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/pdf', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/zip', 'application/vnd.rar'],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 100 * 1024 * 1024, // 100MB
    },
    maximum: {
      type: Number,
      default: 1,
    },
    timeout: {
      type: Number,
      default: 30 * 60 * 1000,
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // files: [],
      file: {
        name: '',
        size: 0,
        type: '',
        extention: '',
        mimetype: '',
        url: '',
        link: '',
        isImage: false,
        isVideo: false,
        isAudio: false,
        isUploaded: false,
        file: null,
        error: '',
        progress: '',
        progressText: '',
        timeout: 1800,
        speed: 0,
        active: false,
        success: false,
        headers: null,
        data: null,
        uploader: null,
        fileObject: true,
      },
      errors: [],
      uploaders: [],
      localValue: '',
    }
  },
  computed: {
    isConnected() {
      return this.$store.state.files.network_avaible
    },
    files: {
      get() {
        return this.value || [];
      },
      set(val) {
        // console.log('val', val);
      },
    },
  },
  methods: {
    renderThumb() {
      // Load the FileReader API
      // const reader = new FileReader();
      // reader.addEventListener(
      //   'load',
      //   () => {
      //     // Set file data
      //     this.file = {
      //       name: fileName,
      //       size,
      //       mimetype,
      //       extension,
      //       isImage,
      //       isAudio,
      //       isVideo,
      //       url: reader.result,
      //       isUploaded: true,
      //     };
      //     this.emitFileInput(this.file);
      //   },
      //   false,
      // );
    },
    resetFileInput(fileObject) {
      const inputElement = document.getElementById(this.inputId);
      inputElement.value = [];
    },
    emitFileInput(fileObject) {
      this.$emit('input-file', fileObject)
    },
    emitFileFilter(fileObject) {
      this.$emit('input-filter', fileObject)
    },
    checkIsImage(extension, mimetype) {
      // advance check
      let ret = this.imageExtensions.includes(extension);
      if (!ret) {
        // simple check
        if (/^image/.test(mimetype) /** && /(mp3|wav|oga|ogg|weba|webm|3gp|aac|ac3|m4a|m2a|m4a|wma)/.test(extension) */) {
          ret = true
        }
      }
      return ret;
    },
    checkIsAudio(extension, mimetype) {
      // advance check
      let ret = this.audioExtensions.includes(extension);
      if (!ret) {
        // simple check
        if (/^audio/.test(mimetype) /** && /(mp3|wav|oga|ogg|weba|webm|3gp|aac|ac3|m4a|m2a|m4a|wma)/.test(extension) */) {
          ret = true
        }
      }
      return ret;
    },
    checkIsVideo(extension, mimetype) {
      // advance check
      let ret = this.videoExtensions.includes(extension);
      // console.log('checkIsVideo: ', extension, mimetype, ret, this.videoExtensions);
      if (!ret) {
        ret = this.videoMimetypes.includes(mimetype);
        // simple check
        if (!ret) {
          if (/^video/.test(mimetype) /** && /(mp3|wav|oga|ogg|weba|webm|3gp|aac|ac3|m4a|m2a|m4a|wma)/.test(extension) */) {
            ret = true
          }
        }
      }
      return ret;
    },
    handleFileChange(e) {
      this.errors = [];
      // Check if file is selected
      if (e.target.files) {
        e.target.files.forEach((file, index) => {
          // console.log(file);

          // Get file size
          const { size } = file;
          // Get file mimetype
          const mimetype = file.type;
          // Get file extension
          const extension = file.name.split('.').pop().toLowerCase();
          // Get file name
          const fileName = file.name.split('.').slice(0, -1).join('.')
          // Check if file is an image
          const isImage = this.checkIsImage(extension, mimetype);
          const isVideo = this.checkIsVideo(extension, mimetype);
          const isAudio = this.checkIsAudio(extension, mimetype);
          const url = URL.createObjectURL(file);
          const key = url.split('/').at(-1);

          const newfile = {
            key,
            name: fileName,
            filename: file.name,
            filename_original: file.name,
            size,
            mimetype,
            type: file.type,
            extension,
            isImage,
            isAudio,
            isVideo,
            file,
            error: '',
            success: '',
            progress: '',
            timeout: this.timeout,
            speed: 0,
            active: false,
            validOnServer: false,
            isValid: false,
            duplicated: false,
            headers: this.headers,
            data: null,
            uploader: null,
            uploaded: false,
            deleted: false,
            fileObject: true,
          };
          // console.log('newfile: ', newfile);

          // Check if file is valid
          if (this.isFileValid(newfile)) {
            this.emitFileInput(newfile);
          } else {
            // console.log('Invalid file: ', file.name);
          }
          if (!this.isDuplicate(newfile)) {
            this.files.push(newfile);
          }
        });
        this.$emit('input', this.files);
        this.resetFileInput();
        // console.log('this.files', this.files);
      }
    },
    isDuplicate(newfile) {
      if (this.files.length) {
        const isFound = this.files.some(item => {
          if (item.filename_original === newfile.filename_original) {
            return true;
          }

          return false;
        });
        if (isFound) {
          const msg = 'File trùng lặp';
          newfile.duplicated = true;
          newfile.error = msg;
          this.errors.push(msg);
          this.emitFileFilter(newfile);
        }
        return isFound;
      }
      return false;
    },
    isFileSizeValid(newfile) {
      if (newfile.size > this.size) {
        const fileSizeShort = this.formatFileSize(this.size, 2);
        const msg = `Kích thước tệp phải nhỏ hơn ${fileSizeShort}`;
        this.errors.push(msg);
        newfile.error = msg;
        return false
      }
      return true;
    },
    isFileTypeValid(newfile) {
      // check wildcard
      if (/\/*/.test(this.accept)) {
        return true;
      }
      // check every mimetype
      if (!this.accept.split(',').includes(newfile.mimetype)) {
        // console.log('error --> mimetype', newfile.mimetype);
        // const msg = `Chỉ hỗ trợ định dạng: ${this.acceptExtensions.replace(',', ', ')}`;
        const msg = 'Sai định dạng';
        this.errors.push(msg);
        newfile.error = msg;
        return false;
      }
      return true;
    },
    isFileValid(newfile) {
      this.isFileSizeValid(newfile);
      this.isFileTypeValid(newfile);
      // console.log('isFileValid errors', this.errors.length);
      if (newfile.error === '') {
        newfile.isValid = true;
        this.emitFileFilter(newfile);
        return true;
      }
      newfile.isValid = false;
      this.emitFileFilter(newfile);
      return false;
    },
    upload(fileObject, metas) {
      const { uploader } = fileObject;
      if (uploader) {
        this.resume(fileObject);
      } else {
        const metadata = {
          name: '',
          uploademam: 'true',
          contentType: 'application/octet-stream',
          emptyMetaKey: '',
          ...metas,
        };
        console.log('metas --> ', metadata);
        // console.log('upload --> fileObject.file: ', fileObject.file);
        const newUploader = new tus.Upload(fileObject.file,
          {
            endpoint: this.chunkOptions.endpoint,
            addRequestId: true,
            onBeforeRequest(req) {
              // console.log('onBeforeRequest req==>', req);
            },
            onAfterResponse(req, res) {
              // console.log('onAfterResponse req==>', req, 'res', res);
            },
            onError: (error) => this.onError(fileObject, error),
            onProgress: (bytesUploaded, bytesTotal) => this.onProgress(fileObject, bytesUploaded, bytesTotal),
            onSuccess: () => this.onSuccess(fileObject),
            chunkSize: this.chunkOptions.chunkSize || 10 * 1024 * 1024,
            retryDelays: this.chunkOptions.retryDelays || [0, 1000, 3000, 5000],
            metadata,

          });
        newUploader.findPreviousUploads().then((previousUploads) => {
          if (previousUploads.length) {
            newUploader.resumeFromPreviousUpload(previousUploads[0]);
          }
          newUploader.start();
          fileObject.active = true;
          fileObject.error = '';
          fileObject.success = '';
        }).catch(() => {
          newUploader.start();
          fileObject.active = true;
          fileObject.error = '';
          fileObject.success = '';
        });
        // fileObject.uploader = newUploader;

        const fileIndex = this.findIndexFile(fileObject);
        this.uploaders[fileIndex] = newUploader;
      }
    },
    findFile(fileObject) {
      return this.files.find(o => o.key === fileObject.key);
    },
    findIndexFile(fileObject) {
      return this.files.findIndex(o => o.key === fileObject.key)
    },
    findUploader(fileIndex) {
      return fileIndex >= 0 ? this.uploaders[fileIndex] : null;
    },
    remove(fileObject) {
      if (this.files.length) {
        const fileIndex = this.findIndexFile(fileObject);
        const uploader = this.findUploader(fileIndex);
        if (uploader) {
          uploader.abort();
        }
        fileObject.error = 'Đã xóa file';
        fileObject.active = false;
        fileObject.deleted = true;

        // this.files[fileIndex] = fileObject;
        this.files.splice(fileIndex, 1);
        this.uploaders.splice(fileIndex, 1);

        this.resetFileInput();
      }
    },
    resume(fileObject) {
      // const { uploader } = fileObject;
      const fileIndex = this.findIndexFile(fileObject)
      const uploader = this.findUploader(fileIndex);
      // console.log('resume ---> uploader', uploader);
      if (uploader) {
        uploader.findPreviousUploads().then((previousUploads) => {
          if (previousUploads.length) {
            uploader.resumeFromPreviousUpload(previousUploads[0]);
          }
          uploader.start();
          fileObject.active = true;
          fileObject.error = '';
          fileObject.success = '';
        }).catch(() => {
          uploader.start();
          fileObject.active = true;
          fileObject.error = '';
          fileObject.success = '';
        });
      }
    },
    cancel(fileObject) {
      // const { uploader } = fileObject;
      const fileIndex = this.findIndexFile(fileObject)
      const uploader = this.findUploader(fileIndex);
      // console.log('cancel ---> uploader', uploader);
      if (uploader) {
        uploader.abort();
        fileObject.success = '';
        fileObject.error = 'Đã tạm dừng';
        fileObject.active = false;
        // this.updateData(fileObject);
      }
    },
    updateData(fileObject) {
      const fileIndex = this.findIndexFile(fileObject)
      // console.log('updateData ---> fileIndex:', fileIndex);
      if (fileIndex) {
        this.files[fileIndex] = fileObject;
        this.$emit('input', this.files);
      }
    },

    onError(fileObject, error) {
      // console.log('onError', error);
      fileObject.error = 'Mất kết nối mạng';
      fileObject.success = '';
      fileObject.active = false;
      this.$emit('upload-error', fileObject)
    },

    onProgress(fileObject, bytesUploaded, bytesTotal) {
      const percentage = (bytesUploaded / bytesTotal * 100).toFixed(2);
      // console.log('onProgress percentage: ', percentage, fileObject);
      fileObject.progress = percentage;
      this.$emit('upload-progress', fileObject)

      // TEST FAIL ==================================
      // if (parseFloat(fileObject.progress) > 50) {
      //   const { uploader } = fileObject;
      //   uploader.abort();
      //   fileObject.active = false;
      //   fileObject.success = '';
      //   fileObject.error = 'Lỗi do đang test';
      //   this.$emit('upload-error', fileObject)
      // }
    },

    onSuccess(fileObject) {
      console.log('onSuccess');
      fileObject.error = ''
      fileObject.success = 'success'
      fileObject.uploaded = true
      this.$emit('upload-success', fileObject)
    },

    formatFileSize(bytes, decimals) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
  },
}
</script>

<style lang="scss">
.file-uploads-html5 {
  position: relative;

  label {
    background: #fff;
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  input {
    background: rgba(255, 255, 255, 0);
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
}
</style>
